
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Moderne Lifte sind in der Regel gut belüftet, daher besteht ein relativ
  geringes Infektionsrisiko durch das Einatmen von infizierter Hintergrundluft.
  Selbst dann, wenn man sich gleichzeitig in einem Aufzug mit einer ansteckenden
  Person befindet. Dennoch sind immer noch viele alte Aufzüge in Betrieb, die
  eher einem geschlossenen Kasten ohne Belüftung ähneln. In diesem Fall ist das
  Risiko viel höher. Das Hauptproblem bei Liften sind aber sowieso nicht
  Aerosole, sondern der enge Kontakt zu atmenden, sprechenden Personen und
  kontaminierte Oberflächen, z.B. Etagenknöpfe. Es sollten sich so wenige
  Personen wie möglich gleichzeitig in einem Lift aufhalten, und alle sollten
  Masken tragen.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;